import { EditTasks as DefaultBulkEditTasksButton } from 'customer-data-bulk-actions/components/buttons/tasks/EditTasks';
import { DefaultBulkActionsUpdateTasksOnSuccess, INVALID_BULK_EDIT_ERROR } from 'customer-data-bulk-actions/hooks/tasksBulkActionsHooks/tasksCrud';
import { useCallback } from 'react';
import { useDispatch } from '../../context/Redux';
import { useTaskDefaults } from '../../hooks/useTaskDefaults';
import { logBulkActionUpdate, mergeTaskPropertyUpdates } from '../../redux/actions/tasksCRUD';
import { GROUP_NAMES, reportNewTasksError } from '../../tracking/errors';
import { Metrics } from '../../tracking/metrics';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BulkEditTasksButton({
  selection,
  clearSelection
}) {
  const dispatch = useDispatch();
  const taskDefaults = useTaskDefaults();
  const onSuccess = useCallback(({
    count,
    propertyUpdates
  }) => {
    DefaultBulkActionsUpdateTasksOnSuccess({
      count
    });
    dispatch(mergeTaskPropertyUpdates({
      taskIds: selection,
      propertyUpdates
    }));
    clearSelection();
  }, [clearSelection, dispatch, selection]);
  const logBulkActionWithExtraInformation = (didRequestSucceed, logInformation) => {
    const {
      error,
      propertyUpdates
    } = logInformation;
    if (!didRequestSucceed && error && error.status === INVALID_BULK_EDIT_ERROR) {
      Metrics.counter('bulk-action-edit-task-invalid-date-reminder-value').increment();
      reportNewTasksError(new Error('Invalid value NaN passed in to bulk edit'), {
        groupName: GROUP_NAMES.TASK_CREATE_UPDATE_DELETE,
        functionName: 'bulkUpdateTasks',
        extra: {
          propertyUpdates,
          // [{ name, value }]
          taskIds: selection,
          taskDefaults
        }
      });
    }
    logBulkActionUpdate(didRequestSucceed, logInformation);
  };
  return /*#__PURE__*/_jsx(DefaultBulkEditTasksButton, {
    modalProps: {
      logFunction: logBulkActionWithExtraInformation,
      onSuccess
    }
  });
}